<ngx-charts-line-chart
  [results]="chartSeriesDataItem"
  [animations]="false"
  noMargin
  [autoScale]="true"
  [showGridLines]="false"
  [xAxis]="xAxis"
  [yAxis]="yAxis"
  [showXAxisLabel]="false"
  [showYAxisLabel]="showYAxisLabel"
  [yAxisLabel]="yAxisLabel ?? ''"
  [timeline]="timeline"
  [customColors]="customColors"
  [scheme]="scheme"
  [curve]="curve"
  [legend]="legend"
  [legendPosition]="LegendPosition.Right"
  [ngStyle]="style$ | async"
>
</ngx-charts-line-chart>
